import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSlab = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.9766 6.63184L17.96 6.63965H17.9873L18.001 9.36426L8.0127 14.877L0.0244141 10.3643L0.015625 7.64062L0 7.63184L9.98828 2.11914L17.9766 6.63184ZM1.03613 8.06543L7.98828 11.9766L16.9404 7.06543L9.98828 3.11719L1.03613 8.06543Z",
		fill: "black"
	})
});
export default SvgSlab;
